import { Mixpanel } from 'mixpanel';
import { BoardSteps } from 'utils/constants';

export const generateFilename = (activeTab: number, step?: string) => {
  if (activeTab === 1) {
    // Board tab - generate filename based on step
    switch (step) {
      case BoardSteps.crop:
        return 'Omya_CrOptimizer_Culture_and_Apports';
      case BoardSteps.fertilization:
        return 'Omya_CrOptimizer_Fertilisation';
      case BoardSteps.mineralization:
        return 'Omya_CrOptimizer_Mineralisation';
      default:
        return 'Omya_CrOptimizer_Board';
    }
  } else if (activeTab === 2) {
    return 'Omya_CrOptimizer_Vue_5_Ans';
  }

  switch (activeTab) {
    case 1:
      return 'Omya_CrOptimizer_Board';
    case 2:
      return 'Omya_CrOptimizer_Vue_5_Ans';
    case 3:
      return 'Omya_CrOptimizer_CropRotation';
    case 4:
      return 'Omya_CrOptimizer_SupplyPlan';
    case 5:
      return 'Omya_CrOptimizer_Synthesis';
    default:
      return 'Omya_CrOptimizer_Board';
  }
};

export const mixpanelTrack = (activeTab: number, step: any, trackProps: any) => {
  switch (activeTab) {
    case 1: {
      switch (step) {
        case BoardSteps.status: {
          Mixpanel.track('Croptimizer (Step 1) – Specifying Current Status pH and Target Status pH and associated parameters (S/CEC)',
            trackProps);
          break;
        }
        case BoardSteps.soil: {
          Mixpanel.track('Croptimizer (Step 2) – Soil Type and Omya Product or MEAC Product',
            trackProps);
          break;
        }
        case BoardSteps.crop: {
          Mixpanel.track('Croptimizer (Step 3) – Crop Yield Gains',
            trackProps);
          break;
        }
        case BoardSteps.fertilization: {
          Mixpanel.track('Croptimizer (Step 4) – Fertilizer Efficiency Gains',
            trackProps);
          break;
        }
        case BoardSteps.mineralization: {
          Mixpanel.track('Croptimizer (Step 5) – Technical/Economic Calculations, Mineralization',
            trackProps);
          break;
        }
      }

      break;
    }
    case 2: {
      Mixpanel.track('Croptimizer (Step 6) – Strategy for 5 years',
        trackProps);
      break;
    }
    case 3: {
      Mixpanel.track('Croptimizer (Step 7) – Crop Rotation Management',
        trackProps);
      break;
    }
    case 4: {
      Mixpanel.track('Croptimizer (Step 8) – Farm Supply Plan',
        trackProps);
      break;
    }
    case 5: {
      Mixpanel.track('Croptimizer (Step 9) – Synthesis',
        trackProps);
      break;
    }
  }
};

export const essentialSteps = [
  {
    id: 1,
    boardStep: BoardSteps.status,
    title: 'Sol',
  },
  {
    id: 1,
    boardStep: BoardSteps.crop,
    title: 'Culture & apports',
  },
  {
    id: 2,
    boardStep: null,
    title: 'Vue 5 ans',
  },
];

export const expertSteps = [
  {
    id: 1,
    boardStep: BoardSteps.status,
    title: 'Sol',
  },
  {
    id: 1,
    boardStep: BoardSteps.crop,
    title: 'Culture & apports',
  },
  {
    id: 1,
    boardStep: BoardSteps.fertilization,
    title: 'Fertilisation',
  },
  {
    id: 1,
    boardStep: BoardSteps.mineralization,
    title: 'Minéralisation',
  },
  {
    id: 2,
    boardStep: null,
    title: 'Vue 5 ans',
  },
];

export const tabArr = [
  {
    id: 1,
    title: 'board',
  },
  {
    id: 2,
    title: 'strategy',
  },
  // INFO
  // CrOptimizer-Simplification task
  // Hide the following pages: Crop Rotation, Supply Plan, Synthesis
  /* { 
    id: 3,
    title: 'cropRotation',
  },
  { 
    id: 4,
    title: 'supplyPlan',
  },
  { 
    id: 5,
    title: 'synthesis',
  }, */
];